<template>
  <tr>
    <td class="calculate-title-text">
      <div class="flex justify-between">
        <span v-html="title"></span>
        <span
          v-if="isResetValue"
          title="Reset to default"
          class="reset-value"
          @click="resetValue"
        ></span>
      </div>
    </td>
    <td class="hidden sm:hidden md:hidden lg:block xl:block 2xl:block border-0">
      
      <div :class="!disabled ? 'slider-custom' : 'slider-custom-disabled'">
        <vue-slider
            ref="slider"
            v-model="total"
            v-bind="options"
            @change="changeSlider"
            :disabled="disabled"
        ></vue-slider>
      </div>
    </td>
    <td class="calculate-title-value relative">
      <input
          class="input"
          type="number"
          :value="total"
          @input="changeValueInput"
          :min="min"
          :max="max"
          :step="interval"
          :disabled="!!disabled"
          number
      >
      <img class="absolute inset-y-0 m-auto right-7" v-if="disabled" src="/images/lock.svg" />
    </td>
  </tr>
</template>

<script>
import SliderCustom from "./SliderCustom";
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
  name: "CalculateRow",
  components: {
    SliderCustom,
    VueSlider,
  },
  props: {
    defaultValue: {
      type: Number,
      default: 0,
    },
    value: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    interval: {
      type: Number,
      default: 0.01,
    },
    name: {
      type: String,
      default: 'update',
    },
    title: {
      type: String,
      default: 'Total Ca, %',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      total: 0,
      options: {
        dotSize: 20,
        width: 'auto',
        height: 8,
        contained: false,
        direction: 'ltr',
        data: null,
        dataLabel: 'label',
        dataValue: 'value',
        min: 0.5,
        max: 1.0,
        interval: 0.1,
        disabled: false,
        clickable: true,
        duration: 0.5,
        adsorb: false,
        lazy: false,
        tooltip: 'active',
        tooltipPlacement: 'top',
        tooltipFormatter: void 0,
        useKeyboard: false,
        keydownHook: null,
        dragOnClick: false,
        enableCross: true,
        fixed: false,
        minRange: void 0,
        maxRange: void 0,
        order: true,
        marks: false,
        dotOptions: void 0,
        dotAttrs: void 0,
        process: true,
        dotStyle: void 0,
        railStyle: void 0,
        processStyle: void 0,
        tooltipStyle: void 0,
        stepStyle: void 0,
        stepActiveStyle: void 0,
        labelStyle: void 0,
        labelActiveStyle: void 0,
      },
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.total = newVal;
      }
    },

    min() {
      if (this.defaultValue) {
        this.total = this.defaultValue;
      }
      this.options = {
        ...this.options,
        min: this.min,
        max: this.max,
        interval: this.interval,
        disabled: this.disabled
      }
    }
  },
  created() {
    if (this.defaultValue) {
      this.total = this.defaultValue;
    }
    this.options = {
      ...this.options,
      min: this.min,
      max: this.max,
      interval: this.interval,
      disabled: this.disabled
    }
  },
  methods: {
    changeValueInput(e) {
      this.total = Number(e.target.value);
      this.$refs.slider.setValue(Number(e.target.value));
      this.changeSlider();
    },
    changeSlider() {
      EventHub.$emit('changeValue', {
        name: this.name,
        value: this.total
      });
    },
    resetValue() {
      this.total = this.defaultValue
      EventHub.$emit('changeValue', {
        name: this.name,
        value: this.total
      });
    }
  },

  computed: {
    isResetValue() {
      return this.total !== this.defaultValue
    }
  }
};
</script>

<style scoped>
  .reset-value {
    cursor: pointer;
    background-image: url('/images/reset-value.svg');
    background-size: contain;
    background-repeat: no-repeat;
    width: 16px;
    height: 16px;
    margin-left: 10px;
  }
</style>
